import { IPropertyCompany } from 'interfaces/IPropertyCompany';
import { ResultParserFn } from './interfaces';

export const getSuggestionParsed = (
  suggestion: IPropertyCompany,
  parseResults?: ResultParserFn,
): IPropertyCompany => parseResults?.([suggestion])?.[0] || suggestion;
